﻿var Slider = require('./slider');
var player = null;
var videoPoster = ROOT + '/static/images/video_default.png';

$(function () {
    var slider = new Swiper('#sliders', {
        autoplay: 4000,
        loop: true,
        pagination: '#sliders-dots',
        paginationClickable: true,
        autoplayDisableOnInteraction: false
    });
    $('#sliders-prev').click(function () {
        slider.swipePrev();
    });
    $('#sliders-next').click(function () {
        slider.swipeNext();
    });

    animateHotSpecials();
    initAds();
    initColumnVods();
});

function initColumnVods() {
    $('.column-navs.boutique').on('click', '.nav', function click() {
        var current = $('.column-navs.boutique .nav.current');
        if (current.data('key') === $(this).data('key')) return;
        current.removeClass('current');
        $(this).addClass('current');
        $('.videos-wrap.boutique').hide();
        $('.videos-wrap.boutique[data-key=' + $(this).data('key') + ']').show();
    });

    $('.column-navs.yst').on('click', '.nav', function click() {
        var current = $('.column-navs.yst .nav.current');
        if (current.data('key') === $(this).data('key')) return;
        current.removeClass('current');
        $(this).addClass('current');
        $('.videos-wrap.yst').hide();
        $('.videos-wrap.yst[data-key=' + $(this).data('key') + ']').show();
    });
}

function initLive() {
    var channels = $('#media-lives .channel');
    if (channels.length) {
        var id = channels.eq(0).attr('data-id');
        getLive(id);
    }
    $('#media-lives').on('click', '.channel', function () {
        channels.removeClass('current');
        $(this).addClass('current');
        getLive($(this).attr('data-id'));
    });
}

function animateHotSpecials() {
    $('#hot-specials').children().eq(0).clone().appendTo($('#hot-specials'));
    $('#hot-specials').children().eq(1).clone().appendTo($('#hot-specials'));
    $('#hot-specials').width($('#hot-specials').width() + 332 * 2);
    var hotSpecials = $('#hot-specials');
    var animating = false;
    var timer;

    $('#hot-specials-operate').on('click', '.prev', function () {
        if (animating) return;
        var left = hotSpecials.css('left').slice(0, -2);
        left = parseInt(left);
        if (left >= 0) {
            var width = hotSpecials.width();
            left = -(width - 332 * 2);
            hotSpecials.css({ left: left + 'px' });
        }

        animating = true;
        hotSpecials.animate(
            {
                left: left + 332 + 'px'
            },
            1000,
            function () {
                animating = false;

                if (timer) {
                    clearInterval(timer);
                    timer = setInterval(function () {
                        $('#hot-specials-operate .next').click();
                    }, 3000);
                }
            }
        );
    });

    $('#hot-specials-operate').on('click', '.next', function () {
        if (animating) return;
        var left = hotSpecials.css('left').slice(0, -2);
        left = parseInt(left);
        var width = hotSpecials.width();
        if (-left >= width - 332 * 2) {
            $('#hot-specials').css({ left: '0px' });
            left = 0;
        }

        animating = true;
        hotSpecials.animate(
            {
                left: left - 332 + 'px'
            },
            1000,
            function () {
                animating = false;
            }
        );
    });

    timer = setInterval(function () {
        $('#hot-specials-operate .next').click();
    }, 3000);

    $(document).on('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
            if (timer) {
                clearInterval(timer);
            }
        } else {
            timer = setInterval(function () {
                $('#hot-specials-operate .next').click();
            }, 3000);
        }
    });
}

function getLive(id) {
    $.get(ROOT + '/tv/' + id, function (data) {
        if (data == '') return;
        if (data.message !== undefined) {
            console.log('获取频道信息错误:' + data.message);
            return;
        }

        if (!data || !data.exdata || !data.exdata.lives || data.exdata.lives.length == 0) {
            console.log('获取直播扩展信息失败');
            console.log(data);
            return;
        }

        var obj = data.exdata.lives[0];
        var urls = [];
        var autoplay = false;

        if (player) {
            player.getPlayer().dispose();
            player = null;
            autoplay = true;
        }
        $('#live').html('');

        if (obj.flv_url) {
            urls.push(obj.flv_url);
        }
        if (obj.m3u8_url) {
            urls.push(obj.m3u8_url);
        }
        if (obj.rtmp_url) {
            urls.push(obj.rtmp_url);
        }

        if (urls.length > 0) {
            var id = 'video_' + new Date().valueOf();
            if (obj.type === 1) {
                $('#live').html('<video id="' + id + '" style="width:100%;height:100%;"></video>');
                player = new DsPlayer('#' + id, {
                    autoplay: autoplay,
                    poster: videoPoster,
                    sources: getSources(urls)
                });
            } else if (obj.type === 2) {
                $('#live').html('<audio id="' + id + '" style="width:100%;height:100%;"></audio>');
                player = new DsPlayer('#' + id, {
                    autoplay: autoplay,
                    poster: videoPoster,
                    sources: getSources(urls)
                });
            }
        }
    });
}

function getSources(urls) {
    var sources = [];

    for (var i = 0; i < urls.length; i++) {
        sources.push({
            src: urls[i]
        });
    }
    return sources;
}

function initAds() {
    $.get(ROOT + '/ad/position/baoliao,middle,home-top-scroll', function success(data) {
        var baoliao = (data || {}).baoliao;
        var middle = (data || {}).middle;
        var topScrollAds = (data || {})['home-top-scroll'];

        var html = '';
        if (baoliao) {
            var ads = (baoliao.ads || []).slice(0, 3);

            if (ads.length) {
                for (var i = 0; i < ads.length; i++) {
                    var ad = ads[i];
                    html += '<div class="middle-ad ad">';
                    html += '   <a href="' + ad.link_url + '" target="_blank" rel="noopener noreferrer">';
                    html += '      <img src="' + ad.picture_url + '?w=432&h=102&s=3" alt="" width="432" height="102" />';
                    html += '      <span class="tag">广告</span>';
                    html += '   </a>';
                    html += '</div>';
                }
                $('.middle-ads').html(html);
            }
        }
        if (html.length === 0) {
            $('.middle-ads').remove();
            $('.notices').css('width', '100%');
        }

        html = '';
        if (middle) {
            var ads = (middle.ads || []).slice(0, 1);

            if (ads.length) {
                for (var i = 0; i < ads.length; i++) {
                    var ad = ads[i];
                    html += '<a href="' + ad.link_url + '" target="_blank" rel="noopener noreferrer">';
                    html += '    <img src="' + ad.picture_url + '?w=1110&h=98&s=3" alt="" width="1110" height="98" />';
                    html += '    <span class="tag">广告</span>';
                    html += '</a>';
                }
                $('.page-middle-ad').html(html);
            }
        }
        if (html.length === 0) {
            $('.page-middle-ad').remove();
        }

        html = '';
        if (topScrollAds) {
            var ads = topScrollAds.ads.filter(function (ad) {
                return ad.type === 2;
            });

            if (ads.length === 0) return;

            $('<img />')
                .attr('src', ads[0].picture_url)
                .on('load', function () {
                    var height = Math.ceil((this.height / this.width) * 10000) / 100 + '%';

                    $('.header-ads-scroll').css({ paddingTop: height });
                    var html = '';
                    ads.forEach(function (ad) {
                        var linkUrl = ad.link_url || 'javascript: void(0);';
                        var target = ad.linkUrl ? '_target' : '';
                        var cover = ad.picture_url;
                        html +=
                            '<div class="swiper-slide"><div class="ad-wrap" style="padding-top: ' +
                            height +
                            ';"><div class="ad-content"><a href="' +
                            linkUrl +
                            '" target="' +
                            target +
                            '"><img src="' +
                            cover +
                            '" alt=""></a></div></div></div>';
                    });

                    $('.header-ads-scroll .swiper-wrapper').html(html);
                    if (ads.length <= 1) {
                        $('.header-ads-scroll .swiper-wrapper').addClass('swiper-no-swiping');
                    }
                    new Swiper('.header-ads-scroll .swiper-container', {
                        loop: true,
                        autoplay: ads.length > 1 ? 5000 : false,
                        mode: 'vertical',
                        noSwiping: true
                    });
                });
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./home/client/js/home.page.js
// module id = 18
// module chunks = 3